// Meta Pixel ID
const PIXEL_ID = '1225835136409461'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
    _fbqInitialized?: boolean
  }
}

/** Inject the Meta Pixel script and fire the initial PageView */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  // Avoid firing PageView more than once per session
  if (window._fbqInitialized) {
    console.log('[MetaPixel] Already initialized, skipping.')
    return
  }
  window._fbqInitialized = true

  // Create the fbq stub so calls can be queued before the script loads
  ;(function (
    f: any,
    b: Document,
    e: string,
    v: string,
    n?: any,
    t?: HTMLScriptElement,
    s?: HTMLScriptElement,
  ) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    t.onload = () =>
      console.log('[MetaPixel] fbevents.js loaded successfully ✓')
    t.onerror = () =>
      console.error(
        '[MetaPixel] fbevents.js failed to load ✗ (ad blocker or network issue?)',
      )
    s = b.getElementsByTagName(e)[0] as HTMLScriptElement
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  console.log('[MetaPixel] Calling fbq init + PageView for pixel:', PIXEL_ID)
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  console.log('[MetaPixel] PageView queued ✓')
}

/** Fire AddToCart event */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  contentName?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) {
    console.warn('[MetaPixel] trackAddToCart called but fbq is not available')
    return
  }
  console.log('[MetaPixel] Firing AddToCart event')
  window.fbq('track', 'AddToCart', {
    value: params?.value ?? 6.39,
    currency: params?.currency ?? 'USD',
    content_name: params?.contentName ?? 'Feline Harmony Blueprint',
    content_type: 'product',
  })
}
